import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import SermonsPage from "@/pages/SermonsPage";
import SermonDetailPage from "@/pages/SermonDetailPage";
import AboutPage from "@/pages/AboutPage";
import EventsPage from "@/pages/EventsPage";
import PrayerRequestsPage from "@/pages/PrayerRequestsPage";
import GalleriesPage from "@/pages/GalleriesPage";
import GalleryDetailPage from "@/pages/GalleryDetailPage";
import ContactPage from "@/pages/ContactPage";
import GivePage from "@/pages/GivePage";
import LiveStreamPage from "@/pages/LiveStreamPage";
import MemberDirectoryPage from "@/pages/MemberDirectoryPage";
import ProfilePage from "@/pages/ProfilePage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

// Context
import { AuthProvider } from "@/context/AuthContext";

function AppRouter() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/sermons" element={<SermonsPage />} />
      <Route path="/sermons/:id" element={<SermonDetailPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/prayer-requests" element={<PrayerRequestsPage />} />
      <Route path="/galleries" element={<GalleriesPage />} />
      <Route path="/galleries/:id" element={<GalleryDetailPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/give" element={<GivePage />} />
      <Route path="/live" element={<LiveStreamPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/unsubscribe" element={<UnsubscribePage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      
      {/* Protected Routes - Any logged in user */}
      <Route path="/profile" element={
        <ProtectedRoute>
          <ProfilePage />
        </ProtectedRoute>
      } />
      
      {/* Protected Routes - Member */}
      <Route path="/members" element={
        <ProtectedRoute requiredRole="member">
          <MemberDirectoryPage />
        </ProtectedRoute>
      } />
      
      {/* Protected Routes - Admin */}
      <Route path="/admin/*" element={
        <ProtectedRoute requiredRole="admin">
          <AdminDashboard />
        </ProtectedRoute>
      } />
      
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-stone-50">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
